// @generated by protoc-gen-connect-es v1.6.1
// @generated from file ai/h2o/mlops/storage/v1/registered_model_version_service.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BatchDeleteModelVersionRequest, BatchDeleteModelVersionResponse, CountModelVersionsRequest, CountModelVersionsResponse, CreateModelVersionRequest, CreateModelVersionResponse, DeleteModelVersionRequest, DeleteModelVersionResponse, GetModelVersionForExperimentRequest, GetModelVersionForExperimentResponse, GetModelVersionRequest, GetModelVersionResponse, ListModelVersionsForModelRequest, ListModelVersionsForModelResponse } from "@buf/h2oai_mlops-storage.bufbuild_es/ai/h2o/mlops/storage/v1/registered_model_version_service_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service ai.h2o.storage.RegisteredModelVersionService
 */
export const RegisteredModelVersionService = {
  typeName: "ai.h2o.storage.RegisteredModelVersionService",
  methods: {
    /**
     * Register the given model version for the specified model id in the message.
     * If the model id is not provided, a new model and version will be created with the
     * given name.
     *
     * @generated from rpc ai.h2o.storage.RegisteredModelVersionService.CreateModelVersion
     */
    createModelVersion: {
      name: "CreateModelVersion",
      I: CreateModelVersionRequest,
      O: CreateModelVersionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets the model versions for the given model id
     *
     * @generated from rpc ai.h2o.storage.RegisteredModelVersionService.ListModelVersionsForModel
     */
    listModelVersionsForModel: {
      name: "ListModelVersionsForModel",
      I: ListModelVersionsForModelRequest,
      O: ListModelVersionsForModelResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets model version for the given registered model id
     *
     * @generated from rpc ai.h2o.storage.RegisteredModelVersionService.GetModelVersion
     */
    getModelVersion: {
      name: "GetModelVersion",
      I: GetModelVersionRequest,
      O: GetModelVersionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets all the model version(s) for an experiment.
     *
     * @generated from rpc ai.h2o.storage.RegisteredModelVersionService.GetModelVersionForExperiment
     */
    getModelVersionForExperiment: {
      name: "GetModelVersionForExperiment",
      I: GetModelVersionForExperimentRequest,
      O: GetModelVersionForExperimentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets model version count for specific model id
     *
     * @generated from rpc ai.h2o.storage.RegisteredModelVersionService.CountModelVersions
     */
    countModelVersions: {
      name: "CountModelVersions",
      I: CountModelVersionsRequest,
      O: CountModelVersionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Delete the model version specified by the id.
     *
     * @generated from rpc ai.h2o.storage.RegisteredModelVersionService.DeleteModelVersion
     */
    deleteModelVersion: {
      name: "DeleteModelVersion",
      I: DeleteModelVersionRequest,
      O: DeleteModelVersionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Delete all the model versions specified by their ids.
     *
     * @generated from rpc ai.h2o.storage.RegisteredModelVersionService.BatchDeleteModelVersion
     */
    batchDeleteModelVersion: {
      name: "BatchDeleteModelVersion",
      I: BatchDeleteModelVersionRequest,
      O: BatchDeleteModelVersionResponse,
      kind: MethodKind.Unary,
    },
  }
};

